import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { setAgeVerificationCookie } from '../../../../mfcLogic/auth'
import { closeDialog } from '../../../../state/modals/state.dialog'
import Button from '../../../Buttons/Button'
import { getThemeSpacing } from '../../../styles/appTheme'
import { maxWindowWidth } from '../../../styles/breakpoints'
import Link from '../../Link'

const StyledRoot = styled('div')({
    padding: getThemeSpacing(2),
    fontSize: '13px',
    '& span': {
        textAlign: 'center',
    },
})

const buttonContainer = css({
    textAlign: 'center',
})

const buttonStyles = css({
    margin: getThemeSpacing(),
    padding: `${getThemeSpacing(0.75)} ${getThemeSpacing(2)}`,
    [maxWindowWidth(360)]: {
        fontSize: 11,
    },
})

const agreeNotice = css({
    fontWeight: 600,
    textAlign: 'center',
})

const goToGoogle = () => {
    document.location.href = 'https://www.google.com/'
}

const onAgree = () => {
    setAgeVerificationCookie()
    closeDialog()
}

const AgeVerification = () => {
    return (
        <StyledRoot data-testid="Container__AgeVerification">
            <div>
                MyFreeCams is an age-restricted adult platform. You must be at
                least 18 years old and agree to this website&apos;s{' '}
                <Link
                    href="https://wiki.myfreecams.com/wiki/Terms_and_Conditions"
                    underline
                    inline
                >
                    Terms and Conditions
                </Link>{' '}
                to enter.
            </div>
            <br />
            <span css={agreeNotice}>Click &quot;I Agree&quot; to enter.</span>
            <br />
            <div css={buttonContainer}>
                <Button
                    onClick={goToGoogle}
                    data-testid="Button__LeaveMFC"
                    css={buttonStyles}
                    size="medium"
                    cancel
                >
                    Leave
                </Button>
                <Button
                    onClick={onAgree}
                    data-testid="Button__EnterMFC"
                    css={buttonStyles}
                    size="medium"
                >
                    I Agree
                </Button>
            </div>
        </StyledRoot>
    )
}

export default AgeVerification
